export const version = "1.0.2-daily-20260421-0";
export const channel = "daily";
export const gitcommit = "a30246ef0";
